import script from "./BusinessHandlingRanking.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessHandlingRanking.vue?vue&type=script&setup=true&lang=js"

import "./BusinessHandlingRanking.vue?vue&type=style&index=0&id=0ebcb5d7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ebcb5d7"]])

export default __exports__